import React from "react";
import { WEDDING, STORY_PHOTOS } from "../utils/config";
import { useTilt } from "../hooks/useTilt";
import { useRef } from "react";
import storyphoto from "../assets/photos/proposal10.jpeg";
import storyphoto4 from "../assets/photos/proposal4.jpeg";
import storyphoto5 from "../assets/photos/proposal6.jpeg";
import storyphoto7 from "../assets/photos/proposal_1.jpeg";

export default function OurStory() {
  return (
    <section
      id="story"
      style={{ padding: "96px 36px", background: "var(--warm)" }}
    >
      <div style={{ maxWidth: "960px", margin: "0 auto" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "56px",
            alignItems: "start",
          }}
          className="grid-2-mobile"
        >
          {/* Photo mosaic */}
          <div className="reveal-left">
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gridTemplateRows: "360px 240px",
                gap: "8px",
              }}
            >
              {STORY_PHOTOS.map((p, i) => (
                <div
                  key={i}
                  className="story-photo"
                  style={{
                    gridRow: p.tall ? "span 2" : "span 1",
                    // background: p.bg,
                    backgroundImage: `url(${p.photo})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "px",
                    overflow: "hidden",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    padding: "18px",
                    cursor: "pointer",
                    boxShadow: "0 8px 24px rgba(36,60,40,.12)",
                  }}
                >
                  <div
                    style={{
                      fontSize: "22px",
                      marginBottom: "6px",
                      position: "relative",
                      zIndex: 1,
                      filter: "drop-shadow(0 2px 4px rgba(0,0,0,.2))",
                    }}
                  >
                    {p.icon}
                  </div>
                  <div
                    style={{
                      fontFamily: "var(--font-serif)",
                      fontStyle: "italic",
                      fontSize: "13px",
                      color: "rgba(255,255,255,.85)",
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    {p.label}
                  </div>
                  <div
                    style={{
                      fontSize: "8px",
                      letterSpacing: ".1em",
                      textTransform: "uppercase",
                      color: "rgba(255,255,255,.45)",
                      marginTop: "3px",
                      position: "relative",
                      zIndex: 1,
                    }}
                  >
                    {p.sub}
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      height: "45%",
                      background:
                        "linear-gradient(transparent,rgba(21,32,24,.55))",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "8px",
                      right: "8px",
                      background: "rgba(255,255,255,.14)",
                      borderRadius: "9px",
                      padding: "2px 8px",
                      fontSize: "7px",
                      color: "rgba(255,255,255,.6)",
                    }}
                  ></div>
                </div>
              ))}
            </div>
            {/* Timeline strip */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3,1fr)",
                gap: "6px",
                marginTop: "8px",
              }}
            >
              {[
                {
                  //bg: "linear-gradient(135deg,#7A9E7E,#4A7250)",
                  //icon: "📖",
                  photo: storyphoto7,
                  label: "Morning of the proposal",
                  //year: "2024",
                },
                {
                  // bg: "linear-gradient(135deg,#9ECFBE,#6B9B7E)",
                  photo: storyphoto5,
                  //icon: "❤️",
                  label: "Engaged",
                  //year: "2022–2024",
                },
                {
                  photo: storyphoto,
                  //bg: "linear-gradient(135deg,#243C28,#3E6642)",
                  //icon: "💍",
                  label: "Emotional",
                  //year: "Dec 2024",
                },
              ].map((s, i) => (
                <div
                  key={i}
                  style={{
                    aspectRatio: "1",
                    borderRadius: "6px",
                    //background: s.bg,
                    backgroundImage: `url(${s.photo})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center Top",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    padding: "10px",
                    textAlign: "center",
                    fontFamily: "var(--font-serif)",
                    fontStyle: "italic",
                    fontSize: "11px",
                    color: "rgba(255,255,255,.82)",
                  }}
                >
                  <div style={{ fontSize: "17px", marginBottom: "4px" }}>
                    {s.icon}
                  </div>
                  {s.label}
                  <div
                    style={{
                      fontSize: "8px",
                      letterSpacing: ".1em",
                      textTransform: "uppercase",
                      color: "rgba(255,255,255,.42)",
                      marginTop: "3px",
                    }}
                  >
                    {s.year}
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* Text */}
          <div className="reveal-right">
            <div className="section-tag">Our Story</div>
            <h2 className="section-title">
              How forever <em>began</em>
            </h2>
            <p
              style={{
                fontSize: "14px",
                lineHeight: 1.95,
                color: "var(--muted)",
                marginTop: "20px",
              }}
            >
              {WEDDING.storyParagraph1}
            </p>
            <p
              style={{
                fontSize: "14px",
                lineHeight: 1.95,
                color: "var(--muted)",
                marginTop: "13px",
              }}
            >
              {WEDDING.storyParagraph2}
            </p>
            <div
              className="story-photo"
              style={{
                borderRadius: "8px",
                marginTop: "18px",
                minHeight: "340px",
                //background: "linear-gradient(145deg,#4A7250,#243C28)",
                backgroundImage: `url(${storyphoto4})`,
                backgroundSize: "cover",
                backgroundPosition: "center 30%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-end",
                position: "relative",
                overflow: "hidden",
                boxShadow: "0 8px 24px rgba(36,60,40,.12)",
              }}
            >
              <div
                style={{
                  fontSize: "26px",
                  marginBottom: "7px",
                  filter: "drop-shadow(0 2px 4px rgba(0,0,0,.2))",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                🌅
              </div>
              <div
                style={{
                  fontFamily: "var(--font-serif)",
                  fontStyle: "italic",
                  fontSize: "13px",
                  color: "rgba(255,255,255,.8)",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                She said Yes! July 2025
              </div>
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(transparent 40%,rgba(21,32,24,.5))",
                }}
              />
            </div>
            {/* Bible verse */}
            <div
              style={{
                marginTop: "24px",
                padding: "16px 20px",
                borderLeft: "2px solid var(--sage-p)",
                fontFamily: "var(--font-serif)",
                fontStyle: "italic",
                fontSize: "17px",
                color: "var(--sage-d)",
                lineHeight: 1.7,
              }}
            >
              "Where you go I will go, and where you stay I will stay."
              <cite
                style={{
                  display: "block",
                  fontStyle: "normal",
                  fontFamily: "var(--font-sans)",
                  fontSize: "8px",
                  letterSpacing: ".18em",
                  textTransform: "uppercase",
                  color: "var(--muted)",
                  marginTop: "7px",
                }}
              >
                — Ruth 1:16
              </cite>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
